import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";

function GreenPledge() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      <div className="bg-section-1 green-bg-1">
        <div className="wrapper">
          <div className="bg-section-1-1">
            <h2 data-aos="zoom-in">
              Engineering Impact. Scaling Responsibility. Restoring Balance.
            </h2>
            <p data-aos="fade-down">
              At Accel1, climate action isn’t a checkbox—it’s the core of our
              existence.
            </p>
            <p data-aos="fade-down">
              We are building next-generation technology to restore what’s been
              lost, protect what remains, and regenerate what’s possible. Our
              climate pledge is not just a declaration—it’s a systems-level
              commitment embedded in every platform, every product, every
              decision we make.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-section-1 green-bg-2">
        <div className="wrapper">
          <h2 data-aos="zoom-in" className="text-center green-color">
            Our Pledge Principles
          </h2>
          <div className="pledge-wrap">
            <div className="pledge-line"></div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.Pledge1} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>1. Net-Nature Positive by Design</h4>
                <p>
                  We don’t just aim for Net Zero. Our goal is to be Net-Nature
                  Positive—where every platform we build helps sequester more
                  carbon, restore more ecosystems, and regenerate more value
                  than it consumes.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.Pledge2} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>2. Radical Transparency</h4>
                <p>
                  We commit to full transparency of our carbon footprint, water
                  use, and ecological impact across our operations and
                  platforms. Our data is designed to serve not just
                  reporting—but accountability.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.Pledge3} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>3. Climate-Embedded Innovation</h4>
                <p>
                  Every new line of code, every product release, and every
                  partnership is evaluated through the lens of climate
                  resilience, circularity, and social equity.
                </p>
              </div>
            </div>

            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.Pledge4} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-up">
                <h4>4. Empowerment Through Intelligence</h4>
                <p>
                  We pledge to make climate intelligence accessible, actionable,
                  and equitable—especially for governments, frontline
                  communities, and developing economies. Tech for the planet
                  must also be tech for the people.
                </p>
              </div>
            </div>
            <div className="pledge-item">
              <div className="pledge-item-1">
                <img src={assets.Pledge5} alt="" data-aos="zoom-in" />
              </div>
              <div className="pledge-item-2" data-aos="fade-down">
                <h4>5. Science-Aligned, Policy-Supportive</h4>
                <p>
                  We anchor our work in the latest climate science and align
                  with frameworks like the Paris Agreement, IPCC Roadmaps, and
                  UN SDGs. We also actively support state-level climate policies
                  and green budgeting across regions we serve.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-section-1 green-bg-3">
        <div className="wrapper height-inherit">
          <div class="building-section-2-1" data-aos="fade-up">
            <h2 className="green-color">Our Commitments by 2030</h2>

            <div className="building-list">
              <ul>
                <li>
                  Power all Accel1 operations and cloud infrastructure with 100%
                  renewable energy
                </li>
                <li>
                  Achieve net-zero carbon footprint across direct operations and
                  product deployment
                </li>
                <li>
                  Restore and protect 1 million acres of climate-critical
                  ecosystems through technology partnerships
                </li>
                <li>
                  Enable our platforms to reduce 10 million metric tons of CO₂e
                  globally
                </li>
                <li>
                  Create or support 100,000 green jobs across regions via
                  digital climate infrastructure
                </li>
                <li>
                  Maintain open access climate datasets for research, policy,
                  and education
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-section-1 green-bg-4">
        <div className="wrapper">
          <div className="flagship-heading" data-aos="fade-down">
            <h2 className="green-color">
              Beyond Ourselves: Our Collective Climate Contract
            </h2>
            <p>
              We recognize that climate change is not a company problem. It's a
              collective systems failure. That’s why we partner with:
            </p>
          </div>
          <div className="text-center">
            <img
              src={assets.ClimateContract}
              alt="ClimateContract"
              className="img-w-1"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      <div className="bg-section-1 green-bg-5 height-inherit">
        <div className="wrapper">
          <div className="flagship-heading" data-aos="fade-up">
            <h2>Our Climate Pledge Is Active, Not Aspirational.</h2>
            <p>
              We report, review, and renew our progress annually—and we invite
              our partners, peers, and the public to hold us accountable.
            </p>
            <div className="line-1-1">
              Because climate isn’t a department. It’s the design.
            </div>
            <div className="join-us-wrap">
              <h5>Join Us</h5>
              <p>
                If you’re building, funding, governing, or scaling climate
                solutions — let’s do it together.
              </p>
              <a
                href="mailto:climate@accel1.com"
                target="_blank"
                className="button-1"
              >
                climate@accel1.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GreenPledge;
